import { render, staticRenderFns } from "./CitiesSelector.vue?vue&type=template&id=0af04955&scoped=true"
import script from "./CitiesSelector.vue?vue&type=script&lang=ts"
export * from "./CitiesSelector.vue?vue&type=script&lang=ts"
import style0 from "./CitiesSelector.vue?vue&type=style&index=0&id=0af04955&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af04955",
  null
  
)

export default component.exports